import StripSlideshowSdk from '@wix/thunderbolt-elements/src/components/StripSlideshow/corvid/StripSlideshow.corvid';


const StripSlideshow = {
  sdk: StripSlideshowSdk
};


export const components = {
  ['StripSlideshow']: StripSlideshow
};

